// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__3TOIT","options":"AnswerScale_options__4noih","selected":"AnswerScale_selected__4LLY3"};